import { CURRENT_CLIENT } from '@/constants'

type ClientWithLocale = { locale?: string }

/** BCP 47 locale for date/time formatting (default en-AU for all tenants). */
export const CLIENT_LOCALE =
  (CURRENT_CLIENT as ClientWithLocale).locale ?? 'en-AU'

export function formatClientDate(
  input: string | number | Date,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleDateString(CLIENT_LOCALE, options)
}

export function formatClientTime(
  input: string | number | Date,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleTimeString(CLIENT_LOCALE, options)
}

export function formatClientDateTime(
  input: string | number | Date,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString(CLIENT_LOCALE, options)
}

/** Shorthand for medium date + short time in tenant locale. */
export function formatClientDateTimeMedium(input: string | number | Date): string {
  return formatClientDateTime(input, { dateStyle: 'medium', timeStyle: 'short' })
}

export function formatClientDateMedium(input: string | number | Date): string {
  return formatClientDate(input, { dateStyle: 'medium' })
}
